import { inject } from 'vue';
import { gtmKey } from '@/infra/injection-keys';
import type { GtmType } from '@/ui/plugins/gtm';

export function useGtm(): GtmType {
  const gtm = inject(gtmKey);
  if (!gtm) throw new Error('GTM plugin not installed');
  return gtm;
}
